import {
  apiClient,
  createSuccessResponse,
  handleApiError,
} from "../../../../../../shared/api"
import { serializeAuditSaleReopenListQuery } from "../lib/serialize-audit-sale-reopen-list-query.js"

/**
 * @class AuditSaleReopenService
 * @description Chamadas HTTP para auditoria de reabertura de venda
 */
class AuditSaleReopenService {
  constructor() {
    /** @type {string} GET — lista auditorias */
    this.listUrl = "/audit/sale-reopen"
    /** @type {string} prefixo PATCH status do grupo */
    this.groupStatusPathPrefix = "/audit/sale-reopen/group"
  }

  /**
   * Lista grupos de auditoria (`GET /audit/sale-reopen`).
   *
   * Filtros (Swagger): `page`, `pageSize`, `status`, `idsale`, `codIntern`,
   * `operation`, `permission`, `role_code`, `sortBy`, `sortOrder`.
   * `idsale` e `codIntern` são mutuamente exclusivos.
   *
   * @param {import("../lib/serialize-audit-sale-reopen-list-query.js").AuditSaleReopenListQueryInput} [params]
   * @param {RequestInit} [requestOptions]
   * @returns {Promise<{ success: true, status: number, message: string, data: * } | { success: false, message: string, code?: string, status?: number, details?: * }>}
   */
  async getAuditSaleReopenList(params = {}, requestOptions) {
    try {
      const query = serializeAuditSaleReopenListQuery(params)

      const endpoint = query.toString()
        ? `${this.listUrl}?${query.toString()}`
        : this.listUrl

      const response = await apiClient.get(endpoint, {
        cache: "no-store",
        ...requestOptions,
      })
      const payload = response?.data ?? response

      console.log("[AuditSaleReopenService] getAuditSaleReopenList response:", payload)

      return createSuccessResponse(
        payload,
        200,
        "Auditorias de reabertura carregadas com sucesso"
      )
    } catch (error) {
      return handleApiError(error)
    }
  }

  /**
   * Atualiza o status do grupo de auditoria (`PATCH audit/sale-reopen/group/:idgroup/status`).
   * @param {number|string} idGroup — `idgroup` da rota
   * @param {{ status: string }} body — `{ status }` enviado no corpo (equivalente a `req.body.status` no backend)
   * @param {RequestInit} [requestOptions]
   * @returns {Promise<{ success: true, status: number, message: string, data: * } | { success: false, message: string, code?: string, status?: number, details?: * }>}
   */
  async patchAuditGroupStatus(idGroup, body, requestOptions) {
    const id = Number(idGroup)
    if (idGroup == null || idGroup === "" || Number.isNaN(id)) {
      return {
        success: false,
        message: "idGroup inválido",
        code: "INVALID_IDGROUP",
        status: 400,
      }
    }
    try {
      const response = await apiClient.patch(
        `${this.groupStatusPathPrefix}/${id}/status`,
        { status: body?.status },
        { cache: "no-store", ...requestOptions }
      )
      const payload = response?.data ?? response
      return createSuccessResponse(
        payload,
        200,
        "Status do grupo atualizado com sucesso"
      )
    } catch (error) {
      return handleApiError(error)
    }
  }
}

export const auditSaleReopenService = new AuditSaleReopenService()
